import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

const BASE = "/ppi/hh-surveilans";

// Sessions (CRUD)
async function getList(params?: any) {
  const response = await http
    .getDataParam(`${BASE}/sessions`, params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`${BASE}/sessions/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData(`${BASE}/sessions`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`${BASE}/sessions/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`${BASE}/sessions/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Observations (bulk append)
async function bulkObservations(sessionId: number, observations: any[]) {
  const response = await http
    .postData(`${BASE}/sessions/${sessionId}/observations/bulk`, {
      observations,
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateObservation(
  sessionId: number,
  observationId: number,
  data: any
) {
  const response = await http
    .putData(
      `${BASE}/sessions/${sessionId}/observations/${observationId}`,
      data
    )
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroyObservation(
  sessionId: number,
  observationId: number,
  alasan: string
) {
  const response = await http
    .deleteDataParam(
      `${BASE}/sessions/${sessionId}/observations/${observationId}`,
      { data: { alasan_hapus: alasan } }
    )
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Sign (3-tier)
async function submitAuditor(id: number, data: any) {
  const response = await http
    .postData(`${BASE}/sessions/${id}/submit-auditor`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function approveTimPpi(id: number, data: { password: string }) {
  const response = await http
    .postData(`${BASE}/sessions/${id}/approve-tim-ppi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Temuan
async function storeTemuan(sessionId: number, data: any) {
  const response = await http
    .postData(`${BASE}/sessions/${sessionId}/temuan`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateTemuan(sessionId: number, temuanId: number, data: any) {
  const response = await http
    .putData(`${BASE}/sessions/${sessionId}/temuan/${temuanId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroyTemuan(sessionId: number, temuanId: number) {
  const response = await http
    .deleteData(`${BASE}/sessions/${sessionId}/temuan/${temuanId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getTemuanTerbuka(params?: any) {
  const response = await http
    .getDataParam(`${BASE}/temuan-terbuka`, params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Dashboard
async function getDashboard(params?: any) {
  const response = await http
    .getDataParam(`${BASE}/dashboard`, params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getComplianceForUnit(unitId: string) {
  const response = await http
    .getData(`${BASE}/compliance-for-unit/${unitId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// PDF
function printPdf(id: number) {
  window.open(`${http.getAPI()}${BASE}/sessions/${id}/pdf`, "_blank");
}

export default {
  getList,
  find,
  create,
  update,
  destroy,
  bulkObservations,
  updateObservation,
  destroyObservation,
  submitAuditor,
  approveTimPpi,
  storeTemuan,
  updateTemuan,
  destroyTemuan,
  getTemuanTerbuka,
  getDashboard,
  getComplianceForUnit,
  printPdf,
};
